import React, { useContext, useState } from "react";
import { AppContext } from "../../App";

export default function Fqa({ title, titleStyle, leftSection }) {
  const { colors } = useContext(AppContext);
  const [openIndex, setOpenIndex] = useState(null); // null = הכל סגור

  const toggleOpen = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const styles = {
    container: leftSection,
    title: titleStyle,
    paragraph: {
      fontSize: "16px",
      lineHeight: "1.6",
      color: colors.text,
      marginBottom: "10px",
    },
    button: {
      background: "none",
      border: "none",
      color: colors.primary,
      cursor: "pointer",
      fontSize: "14px",
      padding: 0,
      textDecoration: "underline",
    },
  };

  const contentData = [
    {
      id: 1,
      question: "#איך מתכוננים לשבוע ישיבה?",
      summary:
        "מה אתה בודק בישיבה שאליה אתה הולך לשבו\"ש? שיש שיעורים מעניינים? שאתה מתחבר לחבר'ה?",
      answer: `הגיע הזמן להתחיל לחשוב בצורה רחבה, לטווח ארוך. אנו רגילים מידי לשאול את עצמנו "לאן הערב".
        עכשיו צריך לשאול – "לאן החיים"…
        
        חשוב לבדוק את הדברים המשמעותיים, שיובילו אותך ללכת לישיבה שבאמת מתאימה לך.
        מה זה ישיבה מתאימה?
        זו ישיבה שתסייע לך ללכת בדרך שבה אתה רוצה ללכת, ישיבה שבה תוכל לבנות את עצמך בצורה אמיתית.
        
        מה זה אומר בפועל?
        כדאי שתגדיר לעצמך – מהם התחומים שאני רוצה להתקדם בהם במהלך לימודי בישיבה? על מה אני רוצה לעבוד כדי להיות במקום טוב יותר?
        בישיבה אנו נבנים בעיקר בשלושת התחומים הבאים:
        1. עבודה על האישיות – להיות אדם טוב יותר, בעל מידות מתוקנות.
        2. השקפת עולם – לגבש עמדה ביחס לחיים, לעולם, לאמונה.
        3. קשר לתורה – להיות אדם שהתורה מהווה חלק בלתי נפרד מהחיים שלו.
        על כל אחד מהתחומים האלה כדאי לחשוב בעצמך לפני שאתה בא לישיבה. בשבוע ישיבה תשאל – אלה התחומים החשובים לי. אלו כלים יש כאן בישיבה שיעזרו לי לקדם את השאיפות שלי?
        
        אם אינך בודק זאת, אתה דומה לאדם שרוצה להגיע לבאר שבע. הוא עולה על אוטובוס ושמח מאוד – האוטובוס ממוזג כראוי, יש סרט טוב, מוזיקה נעימה, אנשים נחמדים. רק בעיה קטנה אחת נשארה – האוטובוס הזה נוסע לצפת…
        למשל – אם אתה חושב ללכת לאוניברסיטה אחרי הישיבה, כדאי שתלך לישיבה שמכשירה אותך לקראת החיים שאחרי הישיבה. ישיבה שיהיה לך כיף להיות בוגר שלה גם כשאתה באוניברסיטה.
        אם הישיבה רואה כ"בוגד", או "נכשל" את מי שהלך לאוניברסיטה – זה כנראה לא האוטובוס שלך…
        
        אם אתה ממש רוצה להשקיע, אתה יכול להכין איזו סוגיא, שאתה מרגיש שלמדת אותה היטב ואתה רוצה לשמוע כיצד לומדים את הסוגיא הזו בישיבות שאתה בודק. אולי יש לך קושיא טובה שלא מצאת עליה תירוץ שמספק אותך.
        במקום להיבחן – תבוא לבחון – איך אתם לומדים גמרא? איך אתם מתמודדים עם הסוגיא הזו?`,
      quote: `לכל ישיבה יש כיוון רוחני מיוחד, שביל ייחודי של לימוד תורה ועבודת ה'.
      אחרי שתברר מה הדרך של הישיבה תחשוב טוב אם זה מה שיתאים להתגדלות הרוחנית שלך,
      ויותר מזה – אם זו התורה שעם ישראל צמא לשמוע בדורנו, דור הגאולה.
      בהצלחה!`,
      author: "הרב נועם אוסטר",
      role: "ר\"מ שיעור א'",
    },

    {
      id: 2,
      question: "#אני לא אוהב ללמוד גמרא…",
      summary: "הרבה חבר'ה מרגישים, שהם לא אוהבים ללמוד גמרא...",
      answer: `הרבה חבר'ה מרגישים, שהם לא אוהבים ללמוד גמרא.
      רק המחשבה על כך שבישיבה לומדים גמרא בצורה רצינית במשך שעות בכל יום גורמת להם לכאב ראש.
      
      ובכן, האם זה שאני לא אוהב ללמוד – זו סיבה לא לבוא לישיבה, או סיבה לבוא לישיבה?
      
      נראה לי, שהתשובה לשאלה הזו לא יכולה להינתן במבט על השנה או השנים הקרובות בלבד.
      כיום אני לא אוהב ללמוד, ונראה לי קשה מאוד להקדיש לכך כמה שנים.
      אבל בוא נסתכל לרגע עוד כמה שנים קדימה.
      האם אתה מבין שכרגע אתה קובע את יחסך לגמרא לכל ימי חייך? שלעולם לא תפתח עוד גמרא?
      זו אחריות גדולה מאוד. לא ניתן לפטור זאת בהינף יד.
      
      בכל הדורות מסרו יהודים את נפשם על לימוד הגמרא. הנה קטעים מספרו של הרב חיים סבתו – "בואי הרוח" (הוצאת ידיעות אחרונות, עמ' 65, ו96):
      
      פרקש אחז בידי וסיפר: כשהגעתי לכפר ביהרנג'יבאיום, שאליו נשלחתי לשמש שוליה של אופה, ללמוד מלאכה זו על בוריה, הייתי נער בר מצוה. יתום ובודד. לא שאלתי איפה אלון, לא שאלתי מה אסעד. שאלה אחת שאלתי כשבאתי לשם: יש כאן שיעור גמרא? לא, לא היה. זה היה כפר קטן של יהודים קשי יום העמלים לפרנסתם, מפטמים אווזים משחר ועד לילה, ובשבת אחרי התפילה מענגים את השבת בשומן אווזים ובעיתון הונגרי. ואני בן היידובסרמן, עירו של רבי יעקב גינז בעל הרי בשמים, בנו של הרבני יוסף פרקש זכרונו לברכה, שרב העיירה התיירא מסברותיו, שכל בוקר השכים שעתיים קודם עלות השחר לעסוק בתורה – וכי יעלה על הדעת שאני אחיה בכפר שלוש וחצי שנים בלי שיעור גמרא? וכי אפשר בכלל ליהודי לחיות בלי דף גמרא? עד אז לא שמעתי על יהודים בלי שיעור גמרא.
      …אחרון נמכר הש"ס הגדול בכריכת העור החומה, שהיה כל כך אהוב על אבא. פעם הרשו לי ללטף את הכריכה. אמא נשקה לכל כרך קודם שנמכר וביקשה מחילה. רק פרוסת לחם וכוס חלב ביקשה. לא לעצמה. מה יכלה לעשות.
      רק גמרא אחת קטנה אמא לא מכרה. מסכת בבא מציעא של אבא, שהיה נושא אותה תמיד בכיס מעילו ולומד בה בדרכים, בעגלות וברכבות. אמא נתנה לי אותה ואמרה: בגמרא זו תלמד כל ימיך, בשבתך בביתך ובלכתך בדרך. גמרא קטנה זו, אמרה לי אמא, ליוותה את אביך בכל דרכיו. גם בשדה הקרב באותו יום מר ונמהר בסרביה במלחמה העולמית היא היתה איתו. על כריכתה סיפר במשפט אחד את המוצאות אותו שם, בשדה הקטל, בעלות השחר. אִתה תזכור את אביך ואת תורתו, את שקידתו ואת העמקתו, את אהבתו לתורה ואת דבקותו באמת. ובבוא היום תעביר את המפתח הזה לבניך אחריך. את הסידור שלו נתן לך אבא ביום מותו. בו תתפלל ובו תתחנן לפני בוראך. שלשלת אחת של זהב, ושני מפתחות לה: הסידור והגמרא.
      
      האם אתה מוכן לנתק את עצמך מהשלשלת הזו? ממסירות הנפש של יהודים בכל הדורות?
      
      ועוד משהו שכדאי שתשים לב אליו.
      בעוד שנים לא רבות, אתה תהיה אבא לילדים. אתה בודאי רוצה שגם ילדיך ימשיכו את השלשלת, ויעבירו הלאה את לפיד התורה והאמונה. כבר היום ניתן לראות, שבדור בו לכל ילד יש סמארטפון ביד – קשה מאוד לקשור ילדים לעולם של תורה וקדושה. המצב רק ילך ויחמיר עם השנים. רק הורים חזקים, יציבים, בעלי עמוד שדרה רוחני ועולם תורה מלא ועשיר יצליחו להעביר זאת לילדיהם.
      אם אתה מוותר לעצמך כבר עכשיו בענין הגמרא – כיצד תצליח להעביר את הקשר לתורה, לתפילה וליהדות לילדיך?!
      
      אם הייתי כותב עכשיו פרסומת ללימודים בישיבה הייתי כותב:
      * אתה לא אוהב ללמוד גמרא?
      * אתה מרגיש שהגמרא שפגשת עד היום "זה לא זה"?
      מקומך איתנו!
      
      דווקא מי שלא אוהב ללמוד גמרא – צריך ללכת לישיבה. בישיבה תקשור קשר חדש עם הגמרא.
      בישיבה תשאל כל הזמן – מה אני יכול לעשות כדי לאהוב את הגמרא? איזה כלים הישיבה יכולה להציע לי כדי ללמוד בשמחה ומתוך הזדהות?
      את השאלות האלה כדאי לך לשאול גם בשבו"ש, ואפשר גם לעשות "מבחן שדה" – האם בישיבה החבר'ה לומדים גמרא בשמחה? האם הישיבה מצליחה במשימה הזו, של לאהוב את הגמרא ?`,
      quote: `כשאתה בוחר ישיבה אתה בוחר בית.
      תעצור, תסתכל סביבך – על ראש הישיבה, הרבנים, ועל החברים מסביב,
      ותראה אם זה המקום שאתה רוצה שיהיה ביתך בשנים הקרובות. ובעצם לכל החיים.
      זה המקום שבונה את עולמך הפנימי הרוחני ונותן לך את עמוד השדרה לכל החיים.
      תנשום עמוק ותקבל את אחת ההחלטות בצומת המרכזית בחייך,
      תתפלל לקב"ה שיעזור לך לבחור את הבחירה הנכונה לטובה ולברכה.
      בהצלחה!`,
      author: "רוני קריגר",
      role: "בוגר הישיבה",
    },
    {
      id: 3,
      question: "מה ההבדל בין מכינה לישיבה? למה דווקא הסדר?",
      summary: `הרבה שואלים: איך אני יכול ללכת לישיבת הסדר, ולא לעשות שלוש שנים צבא?
    האם אני עומד מהצד, כשחברי נלחמים למען מדינת ישראל?
    איך אתה מסביר את זה ל"חילוני"?`,

      answer: [
        `השאלה היא ודאי שאלה טובה, והיא נובעת ממידות טובות ומרצון אמיתי לתרום לחברה. אבל בואו נבדוק רגע, לְמה באמת מדינת ישראל זקוקה כרגע.`,
        `האם מה שחסר לנו זה עוד כמה קצינים או לוחמים?`,
        `א. מה באמת עם ישראל צריך?
    
    מלחמת לבנון השנייה הסתיימה בצורה מבישה למדי. 32,000 חיילי צה"ל לא הצליחו להכניע 8,000 לוחמי חיזבאללה. ועדת וינוגרד קבעה – מה שחסר זה עורף חזק, אמונה, חברה איתנה. והדבר הזה לא בא מהצבא, אלא מבניית אנשים ערכיים.`,
        `ב. התחדשות בתורה
    
    דווקא ישיבות ההסדר היו המקור לחידושים בתורה בעשורים האחרונים – תנ״ך בעוצמה, הלכה למעשה, תורת ארץ ישראל. הרב קוק כתב: "אם התחייה הלאומית לא תחדש לנו הארה בתורה – איננה תחייה אמתית."`,
        `ג. חיבורים
    
    הגמרא אומרת: "כל העוסק בתורה בלבד – דומה כמי שאין לו אלוה" (ע"ז י"ז). הדור שלנו צריך תורה שמחוברת למציאות, לצבא, לחיים. ישיבות ההסדר בונות בדיוק את זה.`,
        `ד. כמה זמן משרתים?
    
    בפועל תלמידי הסדר משרתים בצבא כשנה וחצי, אך נחשבים חיילים ל-4 שנים. הלימוד בישיבה לא פחות תובעני מהשירות הצבאי. סיפור ידוע מהרב כהנמן ממחיש עד כמה לימוד אינטנסיבי דורש כוחות.`,
        `לסיכום:
    
    הסדרניק הוא בן תורה, לוחם, מחובר לחיים. הוא לומד לעומק, מתמודד באמת, ותורם למדינה לא פחות ממי שמשרת בג'בלאות. הוא חלק מהשדרה הרוחנית של עם ישראל.`,
      ],

      quote:
        "לימוד תורה הוא חלק מהותי מהכוח של עם ישראל – לא פחות מהכוח הצבאי.",
      author: "צוות הישיבה",
      role: "",
    },
  ];
  return (
    <div style={styles.container}>
      <h2 style={styles.title}>{title}</h2>

      {contentData.map((e, index) => (
        <div key={index} style={{ marginBottom: "40px" }}>
          <h3 style={{ color: colors.primary }}>{e.question}</h3>

          <p style={styles.paragraph}>{e.summary}</p>

          {/* הצגת תשובה רק אם פתוח */}
          {openIndex === index && (
            <>
              {Array.isArray(e.answer) ? (
                e.answer.map((para, i) => (
                  <p key={i} style={styles.paragraph}>
                    {para}
                  </p>
                ))
              ) : (
                <p style={styles.paragraph}>{e.answer}</p>
              )}

              {e.quote && (
                <blockquote
                  style={{
                    fontStyle: "italic",
                    color: colors.darkBlue,
                    borderRight: "3px solid " + colors.primary,
                    paddingRight: 10,
                    margin: "10px 0",
                  }}
                >
                  “{e.quote}”
                </blockquote>
              )}
              {e.author && (
                <div style={{ fontWeight: "bold", marginTop: "10px" }}>
                  {e.author}
                </div>
              )}
              {e.role && <div>{e.role}</div>}
            </>
          )}

          {/* כפתור קרא עוד / סגור */}
          <button style={styles.button} onClick={() => toggleOpen(index)}>
            {openIndex === index ? "סגור" : "קרא עוד"}
          </button>
        </div>
      ))}
    </div>
  );
}
